module.exports = __webpack_public_path__ + "img/wr_3.d562416f.png";